import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_static/s/login/outdated")({
    beforeLoad: () => {
        throw redirect({
            href: "/",
        });
    },
});
